import { FeatureTokenQueryParam } from '@shared/enums/FeatureTokenType';

const MUTATION = {
	SET_TOKENS: 'SET_TOKENS',
};

const getInitialState = () => ({
	tokens: {},
});

export default {
	namespaced: true,
	state:      getInitialState,
	mutations:  {
		[MUTATION.SET_TOKENS]: (state, tokens) => (state.tokens = tokens),
	},
	actions: {
		/**
		 * Parse feature tokens from URL query parameters and store them.
		 */
		init({ commit }) {
			const urlParams = new URLSearchParams(window.location.search);
			const tokens = {};

			for (const [type, queryParam] of Object.entries(FeatureTokenQueryParam)) {
				if (urlParams.has(queryParam)) {
					tokens[type] = urlParams.get(queryParam);
				}
			}

			commit(MUTATION.SET_TOKENS, tokens);
		},
	},
	getters: {
		tokens:    state => state.tokens,
		hasTokens: state => Object.keys(state.tokens).length > 0,
		getToken:  state => (type) => state.tokens[type] || null,

		/**
		 * Returns the feature token query parameters as a URL query string fragment (without leading ?/&).
		 * Example: "dp=abc123&do=xyz789"
		 */
		queryString: state => {
			const params = new URLSearchParams();
			for (const [type, token] of Object.entries(state.tokens)) {
				const queryParam = FeatureTokenQueryParam[type];
				if (queryParam) {
					params.set(queryParam, token);
				}
			}
			return params.toString();
		},
	},
};
